import React from 'react';

import Grid from '@mui/material/Grid';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import airbnb from 'src/App/assets/airbnbMini.svg';
import { UserListingInfoBar } from 'src/App/HOC';
import { TooltipCard } from '../../HOC';
import { COLOR_PRIMARY, COLOR_RED, COLOR_TOOLTIP_BACKGROUND, MID_GREY } from 'src/const';
import { Listing, ListingLegacy } from 'src/interfaces/idashboard';
import { Alert, Box, Button, Card, CardContent, Chip, Typography } from '@mui/material';
import {
  COLOR_ERROR_1,
  COLOR_ERROR_BACKGROUNG,
  COLOR_PRIMARY_1,
  COLOR_SUCCESS_1,
  COLOR_SUCCESS_BACKGROUNG,
  COLOR_TERTIARY_1_100,
  COLOR_TERTIARY_1_800,
} from 'src/colors';
import { SelecFilterChip } from 'src/App/Components/Chips';
import { isDateBeforeFourWeeks, isMoreThanNDaysAgo } from 'src/utils/functions';
import { InfoTooltip } from 'src/App/HOC/Tooltips';
import { RecentlyAddedChip } from 'src/App/Components/Chips/RecentlyAddedChip';
import ListingInactivityChip from 'src/App/Components/Chips/ListingInactivityChip';
import UnlistedChip from 'src/App/Components/Chips/UnlistedChip';

const TopBar = ({
  onClose,
  isMobileScreen,
  data,
  title,
  isCompListing,
  noListingData,
  isListingRecentlyAdded,
  isListingInactive,
  isListingUnlisted,
  isDemo,
  setIsDemo,
  toggleUrlByDemoListingId,
  userSubscriptionPlan,
}: {
  onClose;
  isMobileScreen: boolean;
  data: any[] | Listing;
  title: string;
  isCompListing?: boolean;
  noListingData?: boolean;
  isListingRecentlyAdded: boolean;
  isListingInactive: boolean;
  isListingUnlisted: boolean;
  isDemo: boolean | null;
  setIsDemo: React.Dispatch<React.SetStateAction<boolean | null>>;
  toggleUrlByDemoListingId: (action: 'set' | 'unset') => void;
  userSubscriptionPlan: string;
}) => {
  return (
    <>
      <Grid
        container
        wrap="nowrap"
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
        sx={{ py: 2, ...(isMobileScreen ? { ml: 0 } : {}) }}
      >
        <Grid item xs={12} md={7}>
          {!noListingData && (
            <Typography variant="h6">
              {isDemo && (
                <Chip
                  label="Demo Listing"
                  color="success"
                  variant="outlined"
                  sx={{ mr: '10px', color: COLOR_PRIMARY_1 }}
                />
              )}
              {isListingRecentlyAdded && (
                <span style={{ marginRight: '10px' }}>
                  <RecentlyAddedChip noShadow={true} />
                </span>
              )}
              {isListingInactive && (
                <span style={{ marginRight: '10px' }}>
                  <ListingInactivityChip
                    activeDaysCount={data['activeDaysCount']}
                    noShadow={true}
                  />
                </span>
              )}
              {isListingUnlisted && (
                <span style={{ marginRight: '10px' }}>
                  <UnlistedChip noShadow={true} />
                </span>
              )}
              {title}
            </Typography>
          )}
        </Grid>

        {/* Close icon on the far right */}
        <Grid item container xs={12} md={5} justifyContent={'flex-end'}>
          {/* TODO FOR FREE USERS */}
          {!isDemo && userSubscriptionPlan === 'starter' && (
            <Button
              variant="contained"
              onClick={() => {
                setIsDemo(true);
              }}
              sx={{
                mr: '10px', color: COLOR_PRIMARY, background: '#fff', '&:hover': {
                  color: '#fff'
                }
              }}
            >
              View Sample Listing
            </Button>
          )}
          <CloseRoundedIcon
            sx={{ cursor: 'pointer', color: COLOR_RED, fontSize: 40 }}
            onClick={() => {
              if (isDemo) {
                setIsDemo(false);
              } else {
                onClose();
              }
            }}
          />
        </Grid>
      </Grid>

      {!isDemo && (
        <Grid container wrap="nowrap" spacing={2} alignItems="center" sx={{ py: 2 }}>
          {!noListingData && data['last_seen'] && isMoreThanNDaysAgo(data['last_seen'], 90) && (
            <Grid item xs={isMobileScreen ? 12 : 8}>
              <InfoTooltip
                title={
                  matchMedia('(hover:hover)').matches ? (
                    <Card>
                      <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
                        <Typography variant="body2" style={{ fontWeight: 500, color: MID_GREY }}>
                          We update listing status every month.
                        </Typography>
                      </CardContent>
                    </Card>
                  ) : (
                    <></>
                  )
                }
              >
                <Alert severity="info">
                  <Typography variant="body2">
                    This listing was last seen active by our system on {data['last_seen']}
                  </Typography>
                </Alert>
              </InfoTooltip>
            </Grid>
          )}
          {isCompListing && !noListingData && (
            <Grid item xs={isMobileScreen ? 12 : 2}>
              <UserListingInfoBar listing={data} />
            </Grid>
          )}
        </Grid>
      )}
    </>
  );
};

export default TopBar;
